<template>
  <div
    @click="toggleSidebar"
    class="filter-button d-flex align-center ga-2"
    :class="[mode]"
  >
    <v-icon size="20" :class="`${mode}-icon`"
      >mdi-filter-multiple-outline</v-icon
    >
    <h2 :class="mode">סינונים</h2>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    mode: {
      type: String,
      default: "customers",
    },
  },
  methods: {
    toggleSidebar() {
      if (this.isMobile || this.isTablet || this.isLaptop) {
        this.$store.commit("setIsOpenMobileSideBar", !this.isOpenMobileSideBar);
      }
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isTablet: "isTablet",
      isLaptop: "isLaptop",
      isOpenMobileSideBar: "isOpenMobileSideBar",
    }),
  },
};
</script>

<style scoped lang="scss">
.filter-button {
  border: 1px solid $grayBorderColor;
  border-radius: 30px;
  width: fit-content;
  padding: 5px 10px !important;
  cursor: pointer;
  background: white;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.v-icon {
  border-radius: 50%;
  padding: 15px;
}

.v-icon.orders-icon {
  color: white;
  background-color: $buttonColor;
}

.customers-icon {
  color: white;
  background-color: $buttonColor;
}

.controlPanel-icon {
  color: white;
  background-color: $controlPanelMainColor;
}

h2 {
  font-size: $mediumTextSize;
  font-weight: 700;
  line-height: 35.55px;
  text-align: right;
  margin: 0px !important;
}

h2.orders {
  color: $ordersMainColor;
}

h2.customers {
  color: $customerMainColor;
}

h2.controlPanel {
  color: $controlPanelMainColor;
}

@include media(mobile) {
  .filter-button {
    position: absolute;
    left: 5px;
    top: 10px;
  }
  h2 {
    font-size: $smallTextSize;
  }
}
</style>
